/**
 * AddExternalPaymentServiceCtrl controller
 * Add/Edit Payment services
 */

import { PAYMENT_SYSTEM_TYPES, EXTERNAL_PAYMENT_SYSTEM_TYPES } from 'app/core/constants'

// controller mixins
AddExternalPaymentServiceCtrl.mixes = [
  ['m2mCtrlMixin', 'payment', 'currencies']
]

/**
 * AddExternalPaymentServiceCtrl controller
 *
 * @class AddExternalPaymentServiceCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:AddExternalPaymentServiceCtrl
 */
/* @ngInject */
export default function AddExternalPaymentServiceCtrl ($uibModalInstance, PaymentSystem, NetworkPaymentSystem, payment, authSvc) {
  var vm = this

  /**
   * Has access
   *
   * @memberOf mwApp/settings.controller:AddExternalPaymentServiceCtrl
   * @function
   */
  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  /**
   * Payment system types
   *
   * @memberof mwApp/packages.controller:AddExternalPaymentServiceCtrl
   * @name vm.payment_system_types
   * @type {Object}
   */
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  /**
   * External Payment Systems Types
   *
   * @memberof mwApp/packages.controller:AddExternalPaymentServiceCtrl
   * @name vm.external_payment_system_types
   * @type {Object}
   */
  vm.external_payment_system_types = EXTERNAL_PAYMENT_SYSTEM_TYPES

  /**
   * PaymentSystem
   *
   * @memberof mwApp/settings.controller:AddExternalPaymentServiceCtrl
   * @type {models.PaymentSystem}
   */
  vm.payment = payment

  /**
   * isNew flag
   *
   * @memberof mwApp/settings.controller:AddExternalPaymentServiceCtrl
   * @type {Boolean}
   */
  vm.isNew = payment._isNew();

  /**
   * Currencies list
   *
   * @memberof mwApp/settings.controller:AddExternalPaymentServiceCtrl
   * @name vm.currencies
   * @type {models.Currency[]}
   */
  // get currencies from extra
  ((payment instanceof NetworkPaymentSystem)
    ? NetworkPaymentSystem.loadExtra(NetworkPaymentSystem.extraFor(payment))
    : PaymentSystem.loadExtra(PaymentSystem.extraFor(payment))
  ).then(data => data.currencies || [])
    .except(payment.currencies) // remove currencies, already existed in payment
    .to(vm.currencies = [])

  /**
   * Create or edit payment, and close modal window afterwards
   *
   * @memberof mwApp/settings.controller:AddExternalPaymentServiceCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    payment._save()
      .then(
        () => {
          payment.password = null // emptying password
          $uibModalInstance.close(payment)
        }
      ).finally(vm.unsetDisable)
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/settings.controller:AddExternalPaymentServiceCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
